
































// Composition
import { defineComponent } from '@vue/composition-api'

// Store
import { storeToRefs } from 'pinia'
import { useSearchStore } from '@/store/search'

// Components
import Product from '@/components/feature/search/results/searchtype/Product.vue'
import Resources from '@/components/feature/search/results/searchtype/Resources.vue'
import Productheader from '@/components/feature/search/results/common/Productheader.vue'

// Types
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

export default defineComponent({
  name: 'ResultsOverview',

  components: {
    Product,
    Resources,
    Productheader,
  },

  setup() {
    const searchStore = useSearchStore()
    const { isProductTab, isResourcesTab, getResults: results } = storeToRefs(searchStore)

    const getID = (result: ElasticFieldsInterface) => {
      return result?._meta?.id !== undefined ? result._meta.id : '0'
    }

    const getScore = (result: ElasticFieldsInterface) => {
      return result?._meta?.score
    }

    const getFilteredResources = (results: ElasticFieldsInterface[]) => {
      return results.filter((result) => result.title?.raw)
    }

    return {
      results,
      getID,
      getScore,
      isProductTab,
      isResourcesTab,
      getFilteredResources,
    }
  },
})
